<template>
  <v-expansion-panels flat accordion multiple :value="[state]" v-model="expanded">
    <v-expansion-panel v-for="(item, i) in serviceList" :key="`about-expandable-${item.id.toString()}`">
      <v-expansion-panel-header
        class="text-uppercase px-0"
        @click="expandHandler(i)"
      >
        <span class="text-tcdc-green header bold">{{ item[`title_${lang}`] }}</span>
        <template v-slot:actions>
          <v-icon v-if="expanded.some(index => i === index)" class="text-tcdc-green" size="medium">mdi-minus</v-icon>
          <v-icon v-else class="text-tcdc-green" size="medium">mdi-plus</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <Service v-if="parseInt(item.layout) === 1" :mode="mode" />
        <News v-if="parseInt(item.layout) === 2" />
        <Partners v-if="parseInt(item.layout) === 3" />
        <SponsorProgram v-if="parseInt(item.layout) === 4" />
        <Network v-if="parseInt(item.layout) === 5" />
        <Location v-if="parseInt(item.layout) === 6 && location && location.branch_id != 5" />
        <Contact v-if="parseInt(item.layout) === 7" />
      </v-expansion-panel-content>
      <Divider />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Divider from "../../components/dividers/Divider";
const Service = () => import("../../components/about_layout/Service");
const News = () => import("../../components/about_layout/News");
const Partners = () => import("../../components/about_layout/Partners");
const SponsorProgram = () => import("../../components/about_layout/SponsorProgram");
const Network = () => import("../../components/about_layout/Network");
const Location = () => import("../../components/about_layout/Location");
const Contact = () => import("../../components/about_layout/Contact");
import { mapState } from 'vuex';

export default {
  components: {
    Divider,
    Service,
    News,
    Partners,
    SponsorProgram,
    Network,
    Location,
    Contact
  },
  props: {
    items: {
      default: null
    },
    state: {
      default: null
    },
    mode: {
      default: null
    }
  },
  computed: {
    ...mapState({
      location: state => {
        return state.About.location;
      },
      aboutData: state => {
        return {
          network: state.About.network,
          partner: state.About.partner,
          contact: state.About.contact,
          sponsor: state.About.sponsor
        }
      },
      lang: state => state.Branch.lang
    }),
    stateChange: function () {
      return this.state;
    }
  },
  watch: {
    stateChange: function () {
      if (this.stateChange) {
        this.expanded = [];
        if (this.stateChange === 6 && !this.location) {
          // console.log('push 5', this.expanded)
          this.expanded.push(5)
        } else {
          // console.log('push else', this.expanded)
          this.expanded.push(this.stateChange)
        }
      }
    },
    lang: function() {
      this.serviceList = [
        {
          id: "111",
          title_th: 'บริการ',
          title_en: 'Service',
          layout: "1"
        },
        {
          id: "112",
          title_th: 'ข่าว',
          title_en: 'News',
          layout: "2"
        },
        // {
        //   id: "113",
        //   title_th: 'หุ้นส่วน',
        //   title_en: 'Partners',
        //   layout: "3"
        // },
        {
          id: "114",
          title_th: 'ผู้สนับสนุน',
          title_en: 'Sponsor Program',
          layout: "4"
        },
        {
          id: "115",
          title_th: 'เครือข่าย',
          title_en: 'Network',
          layout: "5"
        },
        {
          id: "116",
          title_th: 'สถานที่',
          title_en: 'Location',
          layout: "6"
        },
        {
          id: "117",
          title_th: 'ติดต่อ',
          title_en: 'Contact',
          layout: "7"
        }
      ];

      if (!this.location || this.location.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.location'))
      }

      if (!this.aboutData.network || this.aboutData.network.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.network'))
      }

      if (!this.aboutData.sponsor || this.aboutData.sponsor.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.sponsor'))
      }

      // if (!this.aboutData.partner || this.aboutData.partner.length === 0) {
      //   this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.partners'))
      // }

      if (!this.aboutData.contact || this.aboutData.contact.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.contact'))
      }
    },
    location: function() {
      if (!this.location || this.location.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.location'))
      } else {
        this.serviceList = [
          {
            id: "111",
            title_th: 'บริการ',
            title_en: 'Service',
            layout: "1"
          },
          {
            id: "112",
            title_th: 'ข่าว',
            title_en: 'News',
            layout: "2"
          },
          // {
          //   id: "113",
          //   title_th: 'หุ้นส่วน',
          //   title_en: 'Partners',
          //   layout: "3"
          // },
          {
            id: "114",
            title_th: 'ผู้สนับสนุน',
            title_en: 'Sponsor Program',
            layout: "4"
          },
          {
            id: "115",
            title_th: 'เครือข่าย',
            title_en: 'Network',
            layout: "5"
          },
          {
            id: "116",
            title_th: 'สถานที่',
            title_en: 'Location',
            layout: "6"
          },
          {
            id: "117",
            title_th: 'ติดต่อ',
            title_en: 'Contact',
            layout: "7"
          }
        ];
        if (!this.aboutData.network || this.aboutData.network.length === 0) {
          this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.network'))
        }

        if (!this.aboutData.sponsor || this.aboutData.sponsor.length === 0) {
          this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.sponsor'))
        }

        // if (!this.aboutData.partner || this.aboutData.partner.length === 0) {
        //   this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.partners'))
        // }

        if (!this.aboutData.contact || this.aboutData.contact.length === 0) {
          this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.contact'))
        }
      }
    },
    aboutData: function () {
      if (!this.location || this.location.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.location'))
      }

      if (!this.aboutData.network || this.aboutData.network.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.network'))
      }

      if (!this.aboutData.sponsor || this.aboutData.sponsor.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.sponsor'))
      }

      // if (!this.aboutData.partner || this.aboutData.partner.length === 0) {
      //   this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.partners'))
      // }

      if (!this.aboutData.contact || this.aboutData.contact.length === 0) {
        this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.contact'))
      }
    }
  },
  data: () => ({
    expanded: [],
    serviceList: [
      {
        id: "111",
        title_th: 'บริการ',
        title_en: 'Service',
        layout: "1"
      },
      {
        id: "112",
        title_th: 'ข่าว',
        title_en: 'News',
        layout: "2"
      },
      // {
      //   id: "113",
      //   title_th: 'หุ้นส่วน',
      //   title_en: 'Partners',
      //   layout: "3"
      // },
      {
        id: "114",
        title_th: 'ผู้สนับสนุน',
        title_en: 'Sponsor Program',
        layout: "4"
      },
      {
        id: "115",
        title_th: 'เครือข่าย',
        title_en: 'Network',
        layout: "5"
      },
      {
        id: "116",
        title_th: 'สถานที่',
        title_en: 'Location',
        layout: "6"
      },
      {
        id: "117",
        title_th: 'ติดต่อ',
        title_en: 'Contact',
        layout: "7"
      }
    ]
  }),
  created() {
    if (this.state) {
      if (this.state === 6 && !this.location) {
        this.expanded.push(5)
      } else {
        this.expanded.push(this.state)
      }
    }
    if (!this.location || this.location.length === 0) {
      this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.location'))
    }
    if (!this.aboutData.network || this.aboutData.network.length === 0) {
      this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.network'))
    }
    if (!this.aboutData.sponsor || this.aboutData.sponsor.length === 0) {
      this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.sponsor'))
    }
    // if (!this.aboutData.partner || this.aboutData.partner.length === 0) {
    //   this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.partners'))
    // }
    if (!this.aboutData.contact || this.aboutData.contact.length === 0) {
      this.serviceList = this.serviceList.filter(x => x[`title_${this.lang}`] !== this.$t('service.contact'))
    }
  },
  methods: {
    expandHandler(index) {

    }
  }
};
</script>

<style></style>
